export default "__VITE_ASSET__yc7D6rCO__"